import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Button,
  CloseButton,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useAuth } from "../Auth/AuthContext";
import { authFetch } from "../Api/apiConfig";
import { getOrganizerProfile } from "../Api/authApi";

const OrganizerProfileModal = ({ show, handleClose }) => {
  const { handleOrganizerProfileComplete, handleLogin } = useAuth();
  const [formData, setFormData] = useState({
    organization_name: "",
    short_bio: "",
    city: "",
    country: "India",
    address: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (show) {
      const fetchOrganizerData = async () => {
        try {
          const data = await getOrganizerProfile();
          setFormData({
            organization_name: data.organization_name || "",
            short_bio: data.short_bio || "",
            city: data.city || "",
            country: data.country || "India",
            address: data.address || "",
          });
        } catch (err) {
          console.error("Failed to fetch organizer profile:", err);
        }
      };
      fetchOrganizerData();
    }
  }, [show]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      await authFetch("/organizers/me/", {
        method: "PATCH",
        body: JSON.stringify({
          ...formData,
          profile_complete: true,
        }),
      });

      handleOrganizerProfileComplete();
      await handleLogin(); // Refresh user state to update navbar
      setSuccess("Profile completed successfully!");
      setTimeout(() => {
        handleClose();
        setFormData({
          organization_name: "",
          short_bio: "",
          city: "",
          country: "",
          address: "",
        });
      }, 1500);
    } catch (err) {
      setError(err.message || "Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal-size"
    >
      <Modal.Body className="auth-modal-body">
        <CloseButton onClick={handleClose} className="close-btn" />

        <div className="heading text-center mb-4">
          <h1 className="title">Complete Your Organizer Profile</h1>
          <h5 className="subtitle">
            Please provide additional information to start creating events
          </h5>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="organization_name">
            <Form.Label>Organization Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your organization name"
              onChange={handleChange}
              value={formData.organization_name}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="short_bio">
            <Form.Label>Short Bio</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Brief description of your organization"
              onChange={handleChange}
              value={formData.short_bio}
            />
            <small className="text-muted">
              This will be visible to all users
            </small>
          </Form.Group>

          <Form.Group className="mb-3" controlId="city">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your city"
              onChange={handleChange}
              value={formData.city}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="address">
            <Form.Label>Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your business address"
              onChange={handleChange}
              value={formData.address}
              required
            />
          </Form.Group>

          <Button
            type="submit"
            className="btn-gradient w-100 mb-3"
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : "Complete Profile"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default OrganizerProfileModal;
